import React from 'react';

const ApprovalProcessesIndex = React.lazy(() => import("./index"))
const NewApprovalProcesses = React.lazy(() => import("./new"))
const EditApprovalProcesses = React.lazy(() => import("./edit"))

export default[
	{path:'/approval_processes/:id/edit',component: EditApprovalProcesses,name:'Edit ApprovalProcess'},
	{path:'/approval_processes/new',component: NewApprovalProcesses,name:'New ApprovalProcess'},  
	{path:'/approval_processes',component: ApprovalProcessesIndex,name:'ApprovalProcesses'}, 
]

// import ApprovalProcessesRoutes from "modules/approval_processes/web/routes"
// routes = _.concat(routes,ApprovalProcessesRoutes)
